import React, { FC, useState, cloneElement, ReactElement } from 'react'
import { MiniPopup } from '@components/Popup'
import {
  PopupHandlerWrapper,
  PopupContent,
  PopupTitle,
} from './PopupHandler.elements'

type ChildProps = {
  onOpenPopup: () => void
}

type Props = {
  children: ReactElement<ChildProps>
  title: string
  text: string
  action?: 'MiniPopup' // Add more options when needed.
}

export const PopupHandler: FC<Props> = ({
  children,
  title,
  text,
  action,
}) => {
  const [showPopup, setShowPopup] = useState<boolean>(false)

  const handlePopupOpen = () => setShowPopup(true)
  const handlePopupClose = () => setShowPopup(false)

  const handleAction = () => {
    handlePopupOpen()
  }

  const child = cloneElement(children, {
    onAction: action === 'MiniPopup' ? handleAction : undefined
  })

  return (
    <PopupHandlerWrapper>
      {child}

      {showPopup && (
        <MiniPopup
          onClose={handlePopupClose}
          maxWidth={545}
          pushDown
        >
          <PopupTitle
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <PopupContent
            dangerouslySetInnerHTML={{ __html: text }}
          />
        </MiniPopup>
      )}
    </PopupHandlerWrapper>
  )
}
